import React from "react";
import { PageHead } from "@/components/portal/crm/kit";
import { ConnieChat } from "@/components/connie/ConnieChat";

/** Ask Connie — the assistant as a page of its own, in both partner portals. */
export default function AskConnie() {
  return (
    <div className="ask-connie-page" data-testid="ask-connie-page">
      <div className="ask-connie-head">
        <PageHead
          eyebrow="Your Connexis assistant"
          title="Ask Connie"
          lede="Where a case is up to, how anything works, what to do next — or ask her to chase the desk for you."
          testId="ask-connie-head"
        />
      </div>
      <ConnieChat testPrefix="ask-connie" />
    </div>
  );
}
